// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__10ouz","right":"styles_right__3Sjd-"};